import type {
  CoverageMatrixResponsePayload,
  CoverageMatrixValidationResponse,
} from "../types/coverageMatrix";

export async function getCoverageMatrix(projectId: string): Promise<CoverageMatrixResponsePayload> {
  if (!projectId) {
    throw new Error("projectId is required to load coverage matrix");
  }

  const response = await fetch(
    `/api/projects/${encodeURIComponent(projectId)}/discovery/coverage-matrix`,
  );
  const payload = (await response.json()) as CoverageMatrixResponsePayload & {
    ok?: boolean;
    error?: string;
  };

  if (!response.ok || payload?.ok === false) {
    const message = payload?.error ?? `Failed to load coverage matrix (status ${response.status})`;
    throw new Error(message);
  }

  return payload;
}

export async function validateCoverageMatrix(
  projectId: string,
): Promise<CoverageMatrixValidationResponse> {
  if (!projectId) {
    throw new Error("projectId is required to validate coverage matrix");
  }

  const response = await fetch(
    `/api/projects/${encodeURIComponent(projectId)}/discovery/coverage-matrix/validate`,
    { method: "POST" },
  );
  const payload = (await response.json()) as CoverageMatrixValidationResponse & { error?: string };

  if (!response.ok && payload?.ok !== false) {
    const message = payload?.error ?? `Failed to validate coverage matrix (status ${response.status})`;
    throw new Error(message);
  }

  return payload;
}
